import { render, staticRenderFns } from "./uporgselect.vue?vue&type=template&id=47f3cec7&scoped=true&"
import script from "./uporgselect.vue?vue&type=script&lang=js&"
export * from "./uporgselect.vue?vue&type=script&lang=js&"
import style0 from "./uporgselect.vue?vue&type=style&index=0&id=47f3cec7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f3cec7",
  null
  
)

export default component.exports